export const urlSegmentId = 'segment_id'
export const urlSearchTerm = 'search'
